import { Skeleton } from "@/components/ui/skeleton";

/**
 * Skeleton placeholder for sidebar menu groups while
 * role + subscription data is loading. Prevents the
 * "pop-in" flicker of permission-gated menu items.
 */
export function SidebarSkeleton() {
  return (
    <div className="space-y-6 px-3 py-2">
      {/* Group 1 — 4 items */}
      <div className="space-y-1.5">
        <Skeleton className="h-3 w-20 mb-2" />
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={`g1-${i}`} className="h-8 w-full rounded-md" />
        ))}
      </div>
      {/* Group 2 — 3 items */}
      <div className="space-y-1.5">
        <Skeleton className="h-3 w-24 mb-2" />
        {[1, 2, 3].map((i) => (
          <Skeleton key={`g2-${i}`} className="h-8 w-full rounded-md" />
        ))}
      </div>
      {/* Group 3 — 5 items */}
      <div className="space-y-1.5">
        <Skeleton className="h-3 w-28 mb-2" />
        {[1, 2, 3, 4, 5].map((i) => (
          <Skeleton key={`g3-${i}`} className="h-8 w-full rounded-md" />
        ))}
      </div>
    </div>
  );
}
